import React, { useState, useEffect } from "react";
import "./style.css";
import BackIcon from "../../Assets/Icons/BackIcon";
import NavbarCustom from "../../Components/NavbarCustom";
import PreferenceIcon from "../../Assets/Icons/PreferenceIcon";
import { ImageContainer } from "../../Components/ImageContainer";
import { Navigate, Link } from "react-router-dom";
import { useListSports } from "../../APIContext/ListSportsContext";
import { MEDIA_BASE_URL } from "../../Config/Config";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

export const ListOfSports = () => {
  const navigate = useNavigate();

  const { fetchPreferedSportsbyType, preferredSports, allSports } =
    useListSports();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const typeFromQuery = queryParams.get("type");

  const [isOneOnOneClicked, setIsOneOnOneClicked] = useState(true);
  const [isGroupClicked, setIsGroupClicked] = useState(false);
  const [type, setType] = useState(typeFromQuery || "1-1");
  const [selectedSport, setSelectedSport] = useState(null);
  function handleNavigation() {
    Navigate("/preferences");
  }

  function handleOneOnOneClick() {
    setIsOneOnOneClicked(true);
    setIsGroupClicked(false);
    setType("1-1");
  }

  function handleGroupClick() {
    setIsOneOnOneClicked(false);
    setIsGroupClicked(true);
    setType("Group");
  }

  // When Proceed is clicked
  const handleSubmit = () => {
    if (!selectedSport) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please select a sport first!",
        confirmButtonColor: "#B79527",
        cancelButtonColor: "#1C1C1C",
      });
      return;
    }
    navigate(`/book-slots?sport_id=${selectedSport}&type=${type}`);
  };

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (userDetails.is_self_pay === true) {
      navigate("/session-sports?type=1-1");
      return;
    } else {
      if (type) {
        if (type === "1-1") {
          handleOneOnOneClick();
        } else {
          handleGroupClick();
        }
        fetchPreferedSportsbyType(type);
      }
    }
  }, [type]);

  return (
    <>
      <NavbarCustom />
      <div className="sports-container">
        <div className="header">
          <span className="backIcon">
            <BackIcon />
          </span>
          <div className="header-content">
            <h1 className="heading black-text-clip">List of Sports</h1>
            <p className="black-text-clip">Choose a Sport for Your Child</p>
          </div>
        </div>
        <div className="filter-container">
          <div className="space-adjuster"></div>
          <div className="buttons-container">
            <button
              className={`filter-button ${isOneOnOneClicked ? "clicked-btn" : ""}`}
              onClick={handleOneOnOneClick}
            >
              <span className="black-text-clip">1-1</span>
            </button>
            <button
              className={`filter-button ${isGroupClicked ? "clicked-btn" : ""}`}
              onClick={handleGroupClick}
            >
              <span className="black-text-clip">Group</span>
            </button>
          </div>
          <div className="preference-tab">
            <Link to="/preferences">
              <span>
                <PreferenceIcon />
              </span>
              <p className="black-text-clip">Change Preference</p>
            </Link>
          </div>
        </div>

        <div className="preferred-sports">
          <h2 className="black-text-clip">Showing Your Preferred Sports</h2>
          <div className="preferred-sports-container">
            {preferredSports
              ?.filter((item) => item.starting_price > 0)
              .map((item, index) => {
                return (
                  <div
                    key={item.id}
                    className={`sport-card`}
                    onClick={() => setSelectedSport(item.id)}
                  >
                    <ImageContainer
                      id={item.id}
                      name={`${item.name} (${item.sport_type})`}
                      image={item.image}
                      selectedSportId={selectedSport}
                      price={item.starting_price}
                      setSelectedSport={(id) => setSelectedSport(id)}
                    />
                  </div>
                );
              })}
          </div>
        </div>
        <div className="preferred-sports">
          <h2 className="black-text-clip">Other Sports We Have to Offer</h2>
          <div className="preferred-sports-container">
            {allSports
              ?.filter((item) => item.starting_price > 0)
              .map((item, index) => {
                return (
                  <div
                    key={item.id}
                    className={`sport-card list-sport-card`}
                    onClick={() => setSelectedSport(item.id)}
                  >
                    <ImageContainer
                      id={item.id}
                      name={`${item.name} (${item.sport_type})`}
                      image={item.image}
                      selectedSportId={selectedSport}
                      price={item.starting_price}
                      setSelectedSport={(id) => setSelectedSport(id)}
                    />
                  </div>
                );
              })}
          </div>
        </div>
        <button
          disabled={!selectedSport}
          type="submit"
          className="p-submit-button"
          onClick={handleSubmit}
        >
          Proceed
        </button>
      </div>
    </>
  );
};
